import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "field-label" }


export default /*@__PURE__*/_defineComponent({
  __name: 'AppFieldLabel',
  props: {
    label: {},
    icon: { default: "" }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.icon)
      ? (_openBlock(), _createBlock(_component_v_icon, {
          key: 0,
          size: "20"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.icon), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("span", null, _toDisplayString(__props.label), 1)
  ]))
}
}

})